import { Attendee } from "./attendee.model";
import { Contact } from "./contact.model";
import { eSkypeSettings } from "./enum.model";
import { DropDownItem, SimpleResponse } from "./genericResponse.model";
import { Lead } from "./lead.model";
import { keyValue, SearchQueryResponse } from "./search.model";
import { Tag } from "./tagItem.model";

export interface Appt {
  apptID: number;
  cLPUserID: number;
  cLPCompanyID: number;
  category: number;
  generalTypeCode: number;
  contactTypeCode: number;
  leadTypeCode: number;
  proposalTypeCode: number;
  projectTypeCode: number;
  typeID: number;
  strApptStartTime: string;
  apptStartTime: Date;
  apptEndTime: Date;
  isAllDay: boolean;
  isPhoneCall: boolean;
  isPrivate: boolean;
  subject: string;
  location: string;
  notes: string;
  leadID: number;
  contactID: number;
  projectID: number;
  proposalID: number;
  reminderCLP: boolean;
  reminderEmail: boolean;
  reminderTime: Date;
  reminderEmails: string;
  reminderSent: boolean;
  reminderNote: string;
  reminderEmailTemplateID: number;
  showNoteInUserReminder: boolean;
  inApptTemplateID: number;
  documentList: string;
  rApptID: number;
  check1: boolean;
  check2: boolean;
  check3: boolean;
  class1: number;
  status: number;
  campaignID: number;
  campaignEventID: number;
  runID: number;
  dtCreated: string;
  isTxtMsgReminder: boolean;
  isTxtMsgUserReminder: boolean;
  reminderTxtMsgTemplateID: number;
  isOverDue: boolean;
  ContactisShareable: boolean;
  apptUrl: string;
  confirmationTxtMsgTemplateID: number;
    confirmationEmailTemplateID: number;
    contactFirstName: string;
    contactLastName: string;
}

export interface ApptExtended extends Appt {
  userLastFirst: string;
  codeDisplay: string;
  ownerName: string;
  contactName: string;
  companyName: string;
  companyId: number;
  companyType: number;
  score: number;
  lead: Lead;
  contact: Contact;
}

export interface ShareableApptUI {
  apptId: number;
  rApptID: number,
  cat: number;
  ownerId: number;
  leadContactId: number;
  currentUrlAppt: string;
  isNewTab: boolean;
}

export interface UpdateAppt {
  isSave: boolean;
  isCancel: boolean;
  isDelete: boolean;
}

export interface ApptExtendedForCallList extends Appt {
  score: number;
  lead: Lead;
  leadUserFullName: string;
  leadContact: Contact;
  leadContactUserFullName: string;
  contact: Contact;
  contactUserFullName: string;
  apptUserFullName: string;
  codeDisplay: string;
  tags: Tag[];
  qualAttempts: string;
  isQualCall: boolean;
  campaignEvent: CampaignEvent;
  isSelected?: boolean;
  isSaved?: boolean;
  isTagSelected?: boolean;
  fullTagList?: Tag[];
  selectedTagId?: number;
  callListSummary: CallListSummary
}

export interface CallListSummary {
  lastUSPSMailing: {
    mailingStartTime: string,
    subject: string
  },
  isActiveLeadExists: boolean,
  customDate1: string,
  customDate2: string,
  recentEmailList: [
    {
      dtSend: string,
      subject: string,
      result: string
    }
  ],
  recentReferralList: [
    {
      dtCreated: string,
      referral: string
    }
  ],
  lastCompletedAppt: {
    apptStartTime: string,
    subject: string,
    notes: string
  }
}

export interface CampaignEvent {
  campaignEventID: number;
  cLPUserID: number;
  cLPCompanyID: number;
  campaignEventName: string;
  campaignTemplateID: number;
  campaignEventType: number;
  timeSinceValue: number;
  timeSinceUnit: number;
  typeCode: number;
  apptStartTime: string;
  apptLength: number;
  reminderLength: number;
  reminderCLP: number;
  reminderEmail: boolean;
  reminderEmails: string;
  subject: string;
  notes: string;
  emailTemplateID: number;
  mailMergeTemplateID: number;
  documentList: string;
  ownerCLPUserID: number;
  toChoice: number;
  toField: string;
  cCField: string;
  bCCField: string;
  emailAddedLink: number;
  mailingCategory: number;
  salutation: number;
  cTAction: number;
  cTCampaignTemplateID: number;
  cTCLPUserID: number;
  fTField: string;
  fTEditType: number;
  fTValue: string;
  alertStatus: boolean;
  score: number;
  sOrder: number;
  dtModified: Date;
  dtCreated: Date;
  txtMsgTemplateID: number;
  confirmationEmailTemplateID: number;
  confirmationTxtMsgTemplateID: number;
  isTxtMsgReminder: boolean;
  isTxtMsgUserReminder: boolean;
  isPromotional: boolean;
}

export interface CampaignTemplate {
  campaignTemplateID: number;
  cLPUserID: number;
  cLPCompanyID: number;
  campaignTemplateType: number;
  campaignTemplateName: string;
  shareable: boolean;
  cycleEvents: boolean;
  delayCycleValue: number;
  delayCycleUnit: number;
  ownerType: number;
  immunityFlag: boolean;
  isViewInCM: boolean;
  dtModified: Date;
  dtCreated: Date;

}

export interface CampaignTemplate extends SimpleResponse {
  campaignTemplate: CampaignTemplate[];
  filterUser: keyValue[];
}

export interface ApptExtendedForCallListCopy extends ApptExtendedForCallList {
  isEditable: boolean;
}
export interface ApptExtendedForCallListResponse extends SimpleResponse {
  apptsExtended: ApptExtendedForCallList[];
  isTxtMsgActive: boolean;
  eSkype: eSkypeSettings;
  filterType: DropDownItem[];

}

export interface ApptResponse extends SimpleResponse {
  appts: Appt[];
  apptsExtended: ApptExtended[];
  UseCompanyModule: boolean;
  isTxtMsgActive: boolean;
}

export interface ApptExtendedSaveRequest extends Appt {
  apptLength: number
  reminderLength: number
  isSendConfirmationUponSave: boolean
  attendeeList: Attendee[]
}

export interface ProposedTimes {
  strProposedTimes: string[]
  dtProposedTimes: Date[]
}

export interface ProposedTimesResponse extends SimpleResponse {
  proposedTimes: ProposedTimes
  attendeeOverLaps: Attendee[]
}

export interface ApptListResponse {
  apptList: ApptExtended[];
}

export interface BulkApptGetRequest {
  tempListID: number;
  contactIds: number[];
  isRestoreAll: boolean;
  searchQuery: SearchQueryResponse;
  savedQueryID: number;
}

export interface BulkApptSaveRequest {
  strdtStart: string
  numPerDay: number
  tempListID: number
  isWeekend: boolean
  subject: string
  contactTypeCode: number
  reminderLength: number
  isReminderCLP: boolean
  isReminderEmail: boolean
  reminderEmails: string
  isPhoneCall: boolean
  selectedManager: number
  casid: number
  savedQueryID: number
  searchQuery: SearchQueryResponse
}

export interface BulkApptProcessStep1Response extends SimpleResponse {
  /* contacts: Contact[]*/
  ApptSelectedContact: ApptSelectedContact[];
}

export interface AppointmenTypeCodeByCategory {
  apptTypeCode: number
  cLPCompanyID: number
  display: string
  colorCode: string
  sOrder: number
}

export interface TempList {
  tempListID: number;
  clpCompanyID: number;
  clpUserID: number;
  status: number;
  dtCreated: string | null;
  blnExists: boolean;
  items: TempListItem[];
}

export interface TempListItem {
  tempListId: number;
  itemId: number;
  blnExists: boolean;
}

export interface TempListResponse {
  tempList: TempList;
}

export enum eQualClickType {
  DidNotContact = 0,
  LeftMessage = 1,
}


export interface ApppointmentResponse extends SimpleResponse {
  appt: Appt;
}


export interface ApptSelectedContact {
  contactID: number;
  cLPUserID: number;
  cLPCompanyID: number;
  companyID: number;
  firstName: string;
  lastName: string;
  companyName: string;
  mobile: string;
  email: string;
  dtModified: string;
  dtCreated: string;
  dtApptStart: string;
}

